<div class="c__product-features">
  <sd-title class="c__title" customClass="brand--h4" [titleLevel]="productFeatures.titleLevel">
    {{ productFeatures.title }}
  </sd-title>
  <button sd-button
    class="c__sizes-guide is-reset"
    icon="icon-arrow-right"
    (click)="openModal()"
    [iconPos]="positionEnum"
  >
    {{ productFeatures.linkName }}
  </button>
</div>
<sd-modal-aside
  [modalPositionInput]="positionEnum"
  asideClass="c__modal-product-features"
  [(isOpened)]="isOpened"
  (isOpenedChange)="isOpened = false"
  [backdrop]="true"
>
  <ng-container *ngTemplateOutlet="modalContent" />
</sd-modal-aside>

<div class="is-hidden" data-testid="hidden">
  <ng-container *ngTemplateOutlet="modalContent" />
</div>

<ng-template #modalContent>
  <div class="c__sizes-guide-container">
    <sd-title class="c__title" customClass="brand--h3" [titleLevel]="2">
      {{ productFeatures.modalFeatures.title }}
    </sd-title>
    <p class="c__description is-medium"> {{ productFeatures.modalFeatures.description }} </p>
    <div class="c__diameter-portions">
      <sd-title class="c__title" customClass="brand--h4" [titleLevel]="3">
        {{ productFeatures.modalFeatures.subtitle }}
      </sd-title>
      <ul class="c__sizes-list">
        @for (feature of productFeatures.modalFeatures?.features; track $index) {
          <li class="c__size-item">
            <span class="c__size-range">
              <sd-icon class="c__diameter-icon" name="icon-diameter" />
              <p class="is-body-s is-bold"> {{ feature.diameter }} </p>
            </span>
            <span class="c__people-number is-body-s is-bold">{{ feature.libelle }}</span>
          </li>
        }
      </ul>
    </div>
  </div>
</ng-template>
